/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Divider,
  Dropdown,
  List,
  Menu,
  message,
  Popconfirm,
  Table,
  Input,
  Space,
} from 'antd';

import {
  DownloadOutlined,
  DownOutlined,
  EnvironmentOutlined,
  LinkOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import * as axios from 'axios';
import moment from 'moment';
import CustomContent from '../../../components/Content/CustomContent';
import {
  getBeaconsAction,
  saveBeaconAction,
} from '../../../actions/AppCms/BeaconActions';

import { history } from '../../../utils/history';
import { host } from '../../../utils/config';
import Authorized from '../../../components/Authorization/Authorized';

const BeaconList = () => {
  const dispatch = useDispatch();

  const [selectedItem, setSelectedItem] = useState(null);

  const { beacons, beaconFilterParams } = useSelector(store => ({
    beacons: store.beaconReducer.beacons,
    beaconFilterParams: store.filterReducer.beaconFilterParams,
  }));

  useEffect(() => {
    dispatch(getBeaconsAction(beaconFilterParams));
  }, [beaconFilterParams]);

  const handleSingleUnassign = () => {
    const values = {
      uniqueId: selectedItem.uniqueId,
      mac: selectedItem.mac,
      pointOfInterestId: null,
      groupId: null,
    };


    dispatch(saveBeaconAction(values)).then(() => {
      message.success('Beacon unassigned!');
    });
  };

  const handleMenuClick = action => {
    if (action.key === 'assign') {
      const updatePath =
        '/assignBeacon/' + selectedItem.uniqueId + '/' + selectedItem.id;

      history.push(updatePath);
    }
  };

  const handleDownload = action => {
    const bearer = localStorage.getItem('userToken');

    let options = {
      url: host + '/api/beacons/export',
      method: 'GET',
      responseType: 'blob', // important
      headers: { Authorization: bearer },
    };
    if (action.key === '1') {
      options = {
        ...options,
        params: {
          all: true,
        },
      };
    }
    axios(options).then(response => {

      const today = new Date();
      const currentDate =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'beacon-reports-' + currentDate + '.csv');
      document.body.appendChild(link);
      link.click();
    });
  };

  const unassign =
    selectedItem &&
    ((selectedItem.poiList && selectedItem.poiList.length > 0) ||
      selectedItem.pointOfInterestGroup !== null) ? (
      <Menu.Item key="unassign">
        <Popconfirm
          title="Sure to unassign?"
          placement="left"
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          onConfirm={() => handleSingleUnassign()}
        >
          <DeleteOutlined />
          Unassign Beacon
        </Popconfirm>
      </Menu.Item>
    ) : (
      ''
    );

  const menu = (
    <Authorized asset="appcms" operation="write">
      <Menu onClick={handleMenuClick}>
        <Menu.Item key="assign">
          <LinkOutlined />
          Assign Beacon
        </Menu.Item>
        {unassign}
      </Menu>
    </Authorized>
  );

  const exportMenu = (
    <Menu onClick={handleDownload}>
      <Menu.Item key="1">
        <DownloadOutlined />
        {' '}All Beacons
      </Menu.Item>
    </Menu>
  );

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
  };

  const handleReset = clearFilters => {
    clearFilters();
  };

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
  });

  const columns = [
    {
      title: 'Unique ID',
      dataIndex: ['uniqueId'],
      key: 'uniqueId',
      ...getColumnSearchProps('uniqueId'),
    },
    {
      title: 'MAC Address',
      dataIndex: ['mac'],
      key: 'mac',
      ...getColumnSearchProps('mac'),
    },
    {
      title: 'Total Scans',
      dataIndex: ['totalScans'],
      key: 'totalScans',
    },
    {
      title: 'Battery Level',
      dataIndex: ['batteryLevel'],
      key: 'batteryLevel',
    },
    {
      title: 'TxPower',
      dataIndex: ['txPower'],
      key: 'txPower',
    },
    {
      title: 'Last Synced Timestamp',
      dataIndex: ['lastSyncedTimestamp'],
      key: 'lastSyncedTimestamp',
      render: lastSyncedTimestamp => (
        <span>
          {lastSyncedTimestamp
            ? moment.unix(lastSyncedTimestamp).format('YYYY-MM-DD HH:mm:ss')
            : ''}
        </span>
      ),
    },
    {
      title: 'Last Synced Location',
      key: 'lastSyncedLocation',
      render: text =>
        text.lastSyncedLocation &&
        text.lastSyncedLocation.latitude &&
        text.lastSyncedLocation.longitude ? (
          <Button
            type="primary"
            shape="circle"
            icon={<EnvironmentOutlined />}
            onClick={() => {
              window.open(
                'http://www.google.com/maps/place/' +
                  text.lastSyncedLocation.latitude +
                  ',' +
                  text.lastSyncedLocation.longitude,
                '_blank',
              );
            }}
          />
        ) : (
          ''
        ),
    },
    {
      title: 'Assigned POI Group',
      dataIndex: ['pointOfInterestGroup'],
      key: 'pointOfInterestGroup',
      render: text =>
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        text ? (
          <a
            aria-hidden="true"
            onClick={() => {
              history.push('/updatePoiGroup/' + text.id);
            }}
          >
            <span>{text.title}</span>
          </a>
        ) : (
          ''
        ),
    },
    {
      title: 'Assigned POI',
      dataIndex: ['poiList'],
      key: 'poiList',
      render: (text, record) =>
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        record.pointOfInterestGroup == null && text.length > 0 ? (
          <a
            aria-hidden="true"
            onClick={() => {
              history.push('/updatePoi/' + text[0].id);
            }}
          >
            <span>{text[0].title}</span>
          </a>
        ) : (
          ''
        ),
    },

    {
      title: 'Action',
      key: 'action',
      render: () => (
        <span>
          <Dropdown overlay={menu} trigger={['click']}>
            <a className="ant-dropdown-link" href="#">
              Actions <DownOutlined />
            </a>
          </Dropdown>
        </span>
      ),
    },
  ];

  return (
    <CustomContent>
      <Dropdown overlay={exportMenu}>
        <Button
          icon={<DownloadOutlined />}
          style={{ float: 'right', marginBottom: 16, marginRight: 16 }}
        >
          Export
        </Button>
      </Dropdown>
      <Divider />
      <Table
        columns={columns}
        dataSource={beacons}
        expandable={{
          expandedRowRender: record => (
            <List
              size="small"
              header={
                <strong>
                  Assigned POIs{' '}
                  {record.pointOfInterestGroup
                    ? ' (' + record.pointOfInterestGroup.title + ')'
                    : ''}
                </strong>
              }
              bordered
              dataSource={record.poiList}
              renderItem={item => (
                <List.Item key={item.id}>{item.title}</List.Item>
              )}
            />
          ),
          rowExpandable: record => record.pointOfInterestGroup !== null,
        }}
        pagination={{
          defaultPageSize: beaconFilterParams.size,
          total: beacons.totalElements,
          showTotal: (total, range) => {
            return `${range[0]}-${range[1]} of ${total} items`;
          },
          showSizeChanger: true,
          pageSizeOptions: [
            '10',
            '20',
            '30',
            '40',
            '50',
            '100',
            '200',
            '500',
            '1000',
          ],
        }}
        // onChange={handleTableChange}
        rowKey={record => record.uniqueId}
        onRow={record => {
          return {
            onClick: () => setSelectedItem(record),
          };
        }}
      />
    </CustomContent>
  );
};

export default BeaconList;
